export default "/Frontend/dist/event-background-grey.d7fe3bf2097f8f327868a16eb7618bd7.svg";